module.exports = __webpack_public_path__ + "static/media/join-the-duel.a8ae5a14.gif";